import PageDropdown from "@/components/page-dropdown/page-dropdown.vue"
import { numberWithSeparator } from '@/utils/format-strings'

export default {
  name: 'ExchangeCash',
  props: {
    exchangeCash: {
      /**
       * in_stock,
       * on_route,
       * altogether
       */
      type: Object,
      required: true
    }
  },
  components: {
    PageDropdown
  },
  methods: {
    getFormatedSumm(summ) {
      return `${numberWithSeparator(summ)} ₽`
    }
  }
}
